/*
  Responsive & breakpoints
 */
export const getFluidSize = ({ minViewport = BREAKPOINT_XXS, maxViewport = BREAKPOINT_MD, minSize, maxSize }) =>
  `min(${maxSize}px, max(${minSize}px, calc(${minSize}px + (${maxSize} - ${minSize}) * ((100vw - ${minViewport}px) / (${maxViewport} - ${minViewport})))))`

export const BREAKPOINT_XXS = 320
export const BREAKPOINT_SM = 840
export const BREAKPOINT_MD = 1280
